class CartNotification extends HTMLElement {
  constructor() {
    super();

    // small delay needed since section is rendered before the element is actually in the DOM
    setTimeout(() => {
      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
      window.onCartNotificationUpdate = this.onCartUpdate.bind(this);
    }, 1);
  }
  onCartUpdate(opts) {
    const { scrollToTop = false, forceRerenderSections = false } = opts || {};
    const $notificationDrawer = document.querySelector("cart-notification") || null;
    const customCallback = () => {
      if (SDG.Data.bagCheckNewItemAdded)
        SDG.Data.bagCheckNewItemAdded();
      if (window.refreshModals)
        window.refreshModals();
      if (window.refreshStoreLocator)
        window.refreshStoreLocator();
      if (window.refreshNmpAddModalEvents)
        window.refreshNmpAddModalEvents();
      if (window.refreshTradeInModal)
        window.refreshTradeInModal();
      if (window.initTradeInModals)
        window.initTradeInModals();
      $(
        '[data-modal-target="modal-net-monthly-pricing-modal"]:not(.js-net-monthly-pricing-modal-trigger)'
      ).on("click", function() {
        if ($(".js-net-monthly-pricing-modal-trigger").length) {
          $(".js-net-monthly-pricing-modal-trigger")[0].click();
        }
      });
      if (scrollToTop) {
        window.scrollTo(0, 0);
      }
    };
    if ($notificationDrawer) {
      return fetch(`${routes.root_url}?section_id=${this.dataset.sectionId}`).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector(".cart-notification-wrapper");
        const headerCounter = html.querySelector(".cart-count-bubble")
        document.querySelector(".cart-count-bubble").innerHTML = headerCounter.innerHTML;
        this.querySelector(".cart-notification-wrapper").innerHTML = sourceQty.innerHTML;
        if (window.location.href.toString().includes('cart')) {
          window.onCartUpdate();
        }
      }).catch((e) => {
        console.error(e);
      });
    }
  }
  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
